import stylesGlobal from '../../screens/style';

const defaultStyle = {
  height: 112,
  padding: '12px 24px 16px',
  color: stylesGlobal.neutral0,
};

const styles = {
  container: {
    ...defaultStyle,
    backgroundColor: '#448bf1',
    boxShadow: stylesGlobal.boxShadow.grey,
  },
  containerGradient: {
    ...defaultStyle,
    backgroundImage: 'linear-gradient(to right, #89b5fb, #0858d9)',
    boxShadow: stylesGlobal.boxShadow.black,
  },
};

export default styles;
